module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_hy300@2x.dfb04afd.png";